import React, { useState, useEffect } from 'react';
import closeIcon from "../../../../assets/images/Icons/close_icon.svg";
import { makeAjax, respStatus, url, showMessage } from '../../../../helpers/global_helper';
import { formatPrice } from "../../../NumberFormat";
import { withTranslation } from "react-i18next";
import { IoMdClose } from "react-icons/io";

const TurnoverDatePopup = (props) => {
    const { onClose, turnoverDateId } = props;
    const [turnoverinfodatedata, setTurnoverInfoDateData] = useState([]);

    // API for Turnover Bonus Date popup
    const fetchTurnoverInfoDateData = () => {
        let reqData = {
            date: turnoverDateId,
        };
        makeAjax(url.PLAYER_API.getTurnover, reqData, url.PLAYER_MS_EXT).then((response) => {
            if (response.status !== respStatus["SUCCESS"]) {
                showMessage("server connection lost", "error", "not getting data");
                return;
            }
            setTurnoverInfoDateData(response.data);
        });
    };

    useEffect(() => {
        if (turnoverDateId) {
            fetchTurnoverInfoDateData();
        }
    }, [turnoverDateId]);

    return (
        <div className="overlay">
            <div className='overlay_innerDiv' onClick={onClose}></div>
            <div className="turnover_info_popup">
                <button className="informasi_popup-close" onClick={onClose}>
                <IoMdClose className="btnclose"/>
                </button>
                <div className="result_txt">
                    {props.t("info_turnover").toUpperCase()}
                    <span className='win_lose_txt'>
                        {props.t("win").toUpperCase()} / {props.t("lose").toUpperCase()}
                    </span>
                </div>

                {/* Table */}
                <div className="informasi_tble_result">
                    <table>
                        <thead>
                            <tr>
                                <th>{props.t("game")}</th>
                                <th>{props.t("win")} / {props.t("lose")}</th>
                                <th>{props.t("turnover")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {turnoverinfodatedata.length === 0 ? (
                                <tr className="table_data_empty_row even-row">
                                    <td colSpan="3">{props.t("data_not_found")}</td>
                                </tr>
                            ) : (
                                turnoverinfodatedata.map((data, index) => (
                                    <tr key={index}  className={index % 2 === 0 ? "even-row" : "odd-row"}>
                                        <td>{data.gamename}</td>
                                        <td>{formatPrice(data.winlose)}</td>
                                        <td>{formatPrice(data.tover)}</td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default withTranslation()(TurnoverDatePopup);
